import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col } from 'react-bootstrap';
import ApexCharts from 'apexcharts';

function ReportCarbono({ dados }) {
    dados = {
        "Emissões Globais": {
            "2025": "9.000,00",
            "2024": "8.000,00",
            "2023": "8.000,00",
            "2022": "6.000,00",
            "2021": "5.000,00"
        },
        "Emissões a partir de Resíduos": {
            "Óleos e gorduras alimentares": {
                "2025": "5.000,00",
                "2024": "3.000,00",
                "2023": "4.000,00",
                "2022": "3.000,00",
                "2021": "4.000,00"
            },
            "Óleos de motores, transmissões e lubrificação usados ou contaminados": {
                "2025": "3.000,00",
                "2024": "3.000,00",
                "2022": "2.000,00",
                "2021": "1.000,00"
            },
            "Lodos de fossas sépticas": {
                "2025": "2.000,00",
                "2024": "2.000,00",
                "2023": "4.000,00",
                "2022": "1.000,00"
            }
        }
    }

    // Pega os grupos
    const categorias = Object.keys(dados["Emissões a partir de Resíduos"]);

    // Coleta todos os anos únicos presentes nos dados
    const anos = Array.from(
        new Set(
            categorias.flatMap((categoria) =>
                Object.keys(dados["Emissões a partir de Resíduos"][categoria])
            )
        )
    ).sort((a, b) => b - a); // Ordenar do mais recente para o mais antigo

    const rendeGraph = (dados) => {
    
        // 1. Converte os valores para número
        const convertToNumber = (str) => parseFloat(str.replace('.', '').replace(',', '.'));
    
        const entradas = Object.entries(dados).map(([ano, valor]) => ({
            x: ano,
            y: convertToNumber(valor)
        }));
    
        // 2. Identifica o maior valor
        const max = Math.max(...entradas.map(e => e.y));
    
        // 3. Aplica cor com base na % do maior valor
        const seriesData = entradas.map(({ x, y }) => {
            let fillColor = '';
    
            const percent = (y / max) * 100;
            // if (percent <= 30) {
            //     fillColor = '#00E396'; // verde
            // } else if (percent <= 70) {
            //     fillColor = '#FFA500'; // laranja
            // } else {
            //     fillColor = '#ff0000'; // vermelho
            // }

            fillColor = '#652FBA';
    
            return { x, y, fillColor };
        });
    
        const options = {
            chart: {
                type: 'bar'
            },
            series: [{
                data: seriesData
            }],
            yaxis: {
                title: {
                    text: 'Emissões (tCO2e)'
                }
            }
        };

        var chart = new ApexCharts(document.querySelector("#chart"), options);
        chart.render();

    }

    useEffect(() => {

        rendeGraph(dados["Emissões Globais"]);

    });


    return (
        <>
            {dados ?
                <>
                    <Row style={{ height: 'calc(100vh - 560px)' }}>
                        <Col>
                            <div id="chart" style={{ width: '500px', margin: '0 auto' }}></div>
                        </Col>
                        <Col className='scrollbar' style={{ height: 'calc(100vh - 560px)', 'overflowX': 'hidden' }}>
                            <table className="table stripedColor" style={{ marginTop: '30px', marginLeft: '15px' }}>
                                <thead>
                                    <tr>
                                        <th>Ano</th>
                                        {anos.map((ano) => (
                                            <th key={ano}>
                                                {ano}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {categorias.map((categoria) => (
                                        <tr key={categoria}>
                                            <td>{categoria}</td>
                                            {anos.map((ano) => (
                                                <td key={ano}>
                                                    {dados["Emissões a partir de Resíduos"][categoria][ano] || "-"}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </>
                : <Row><span className="fs-6">Não foram encontrados dados de carbono</span></Row>}
        </>
    )
}

export default ReportCarbono;